/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Qc_Fix_Applied_ToastInputs */

const en_qc_fix_applied_toast = /** @type {(inputs: Qc_Fix_Applied_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatic fixes applied (${i?.count} changes)`)
};

const fr_qc_fix_applied_toast = /** @type {(inputs: Qc_Fix_Applied_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Corrections automatiques appliquées (${i?.count} modifications)`)
};

const de_qc_fix_applied_toast = /** @type {(inputs: Qc_Fix_Applied_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatische Korrekturen angewendet (${i?.count} Änderungen)`)
};

const it_qc_fix_applied_toast = /** @type {(inputs: Qc_Fix_Applied_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Correzioni automatiche applicate (${i?.count} modifiche)`)
};

const ru_qc_fix_applied_toast = /** @type {(inputs: Qc_Fix_Applied_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Автоматические исправления применены (${i?.count} изменений)`)
};

const es_qc_fix_applied_toast = /** @type {(inputs: Qc_Fix_Applied_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Correcciones automáticas aplicadas (${i?.count} cambios)`)
};

const zh_cn2_qc_fix_applied_toast = /** @type {(inputs: Qc_Fix_Applied_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已应用自动修复（${i?.count} 处更改）`)
};

const ja_qc_fix_applied_toast = /** @type {(inputs: Qc_Fix_Applied_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`自動修正を適用しました（${i?.count}件の変更）`)
};

const hi_qc_fix_applied_toast = /** @type {(inputs: Qc_Fix_Applied_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`स्वचालित सुधार लागू किए गए (${i?.count} बदलाव)`)
};

const pt_pt2_qc_fix_applied_toast = /** @type {(inputs: Qc_Fix_Applied_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Correções automáticas aplicadas (${i?.count} alterações)`)
};

/**
* | output |
* | --- |
* | "Automatic fixes applied ({count} changes)" |
*
* @param {Qc_Fix_Applied_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_applied_toast = /** @type {((inputs: Qc_Fix_Applied_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Applied_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_qc_fix_applied_toast(inputs)
	if (locale === "de") return de_qc_fix_applied_toast(inputs)
	if (locale === "it") return it_qc_fix_applied_toast(inputs)
	if (locale === "ru") return ru_qc_fix_applied_toast(inputs)
	if (locale === "es") return es_qc_fix_applied_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_qc_fix_applied_toast(inputs)
	if (locale === "ja") return ja_qc_fix_applied_toast(inputs)
	if (locale === "hi") return hi_qc_fix_applied_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_qc_fix_applied_toast(inputs)
	return en_qc_fix_applied_toast(inputs)
});